export class ResponseHandler {
    isClientError(status: number) {
        return status >= 400 && status <= 499;
    }
	isServerError(status: number) {
		return status >= 500 && status <= 599;
	}
	isSuccess(status: number) {
		return status && !this.isClientError(status) && !this.isServerError(status);
	}
}